export default "__VITE_ASSET__0YvvTivQ__"